import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import {Input, Spin} from 'antd';
import axios from "axios";
import { orders_uri } from "../../utils/url";
import { toast } from "react-toastify";

export default function RevokeModal({data, callback, type}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);

  const Call = () => {
    callback();
  }

  const Submit = async () => {
    setLoad(true);
    try{
        const res = await axios.patch(orders_uri+`/revoke`, {id: data.id, type: type});
        if(res.status === 200){
            toast.success("Амжилттай");
            onOpenChange(false);
            Call();
        }
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button size="sm" className="bg-orange-400 text-white" onPress={onOpen}>Төлөв буцаах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Та энэ барааны төлөвийг буцаахдаа итгэлтэй байна уу ?</ModalHeader>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
                {
                    load?
                    <Button color="primary">
                        <Spin/>
                    </Button>
                    :
                    <Button color="primary" onPress={Submit}>
                        Тийм
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
